import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setConfigurator } from '../../actions'

import FundingCard from './FundingCard'

const mapStateToProps = state => ({
  wizards: state.wizards,
  configurator: state.configurator
})

const mapDispatchToProps = {
  setWizards,
  setConfigurator
}

export default connect(mapStateToProps, mapDispatchToProps)(FundingCard)
